import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { creditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

creditCardDetailsEntryStyles.creditCardDetailsContainer = mergeToNew(
    creditCardDetailsEntryStyles.creditCardDetailsContainer,
    {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 18px 0 0;
                        `,
                        css`
                            padding: 18px 0 0;
                        `,
                        css`
                            padding: 18px 0 0;
                        `,
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 15px;
                        `,
                    ],
                    "min",
                )}
            input,select {
                margin-bottom: 10px !important;
            }
        `,
    },
);

creditCardDetailsEntryStyles.creditCardDetailsHeadingGridItem = mergeToNew(
    creditCardDetailsEntryStyles.creditCardDetailsHeadingGridItem,
    {
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
);

creditCardDetailsEntryStyles.creditCardDetailsHeading = mergeToNew(
    creditCardDetailsEntryStyles.creditCardDetailsHeading,
    {
        css: css`
            margin-bottom: 3px;
        `,
    },
);

creditCardDetailsEntryStyles.cardHolderNameGridItem = mergeToNew(creditCardDetailsEntryStyles.cardHolderNameGridItem, {
    css: css`
        padding-top: 22px;
    `,
});
